// Tells the SSR to redirect instead of rendering the app
export default function redirectState(state, redirectURL, statusCode = 301) {
	return {
		...state,
		redirectURL,
		statusCode,
	};
}
